import tossKy from '@toss/ky';

class ApiError extends Error {
  status: number;
  data: unknown;

  constructor(message?: string, status?: number, data?: unknown) {
    super(message || '요청 처리 중 오류가 발생했습니다');
    this.status = status || 500;
    this.data = data;
  }
}

/**
 * CSRF 토큰 처리
 *
 * @param request
 * @param options
 * @param response
 */
const handleCsrfToken = async (request: Request, options: any) => {
  if (typeof document === 'undefined') return;
  if(request.method === 'GET' || request.method === 'HEAD' || request.method === 'TRACE' || request.method === 'OPTIONS') return;
  let csrfToken = getCsrfToken();

  if (!csrfToken) {
    const url = new URL(request.url);
    await fetch(`${process.env.NEXT_PUBLIC_SITE_URL}/api/v1/auth/csrf`);
    csrfToken = getCsrfToken();
    if(!csrfToken) return;
  }
  request.headers.set('X-XSRF-TOKEN', csrfToken);
};


/**
 * 오류 메세지 처리
 *
 * @param request
 * @param options
 * @param response
 */
const handleErrorMessage = async (request: Request, options: any, response: Response) => {
  if (response.ok) {
    return response;
  }

  const errorData = await response.clone().json();
  const error = new ApiError(errorData.message || '요청 처리 중 오류가 발생했습니다');
  error.status = response.status;
  error.data = errorData;
  throw error;
};

export const ky = tossKy.create({
  prefixUrl: `${process.env.NEXT_PUBLIC_SITE_URL}/api`,
  credentials: 'include',
  timeout: 60000,
  hooks: {
    beforeRequest: [handleCsrfToken],
    afterResponse: [handleErrorMessage],
  },
});

const getCsrfToken = () => {
  if (typeof document === 'undefined') return undefined;
  const value = document.cookie
    .split('; ')
    .find(row => row.startsWith('XSRF-TOKEN='))
    ?.split('=')[1];
  return value;
};